import React from "react";
import Context from "../../Context";
import ModelList from "../Layout/Model/ModelList";
import Blocker from "./Blocker";
import BsModal from "./BsModal";
import Modal from "./Modal";
export default class ModelPicker extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      listKey: "",

      checkedModels: [],
      searchDefault: [
        {
          field: "statetypecode",
          compare: "EQL",
          value: "enabled",
        },
      ],
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.listKey !== this.props.listKey) {
      this.setState({ listKey: this.props.listKey });
    }
  }

  onModelSelect = () => {
    this.props.onModelPick(this.state.checkedModels);
    this.setState({ checkedModels: [] });
    this.props.onClose();
  };
  onModelPick = (item) => {
    this.props.onModelPick(item);
    this.props.onClose();
  };
  onModelCheck = (item) => {
    this.setState((state) => {
      let checkedModels = state.checkedModels;
      if (checkedModels.includes(item.id)) {
        checkedModels.splice(checkedModels.indexOf(item.id), 1);
      } else {
        checkedModels.push(item.id);
      }
      return { checkedModels };
    });
  };

  onSearch = (v) => {
    this.setState({ searchText: v });
  };

  onCreate = async () => {
    let promptResult = await this.context.prompt("Название нового ЗИП");
    if (promptResult.isConfirmed && promptResult.value) {
      let saveData = {
        name: promptResult.value,
      };
      this.setState({ pending: true });
      let result = await this.context.api.q(`/model/set`, saveData);
      this.setState({ pending: false });
      if (result) {
        if (this.props.onCreate) {
          this.props.onCreate(result);
          this.props.onClose();
        } else {
          this.setState({ listKey: this.context.key() });
        }
      } else {
        this.context.toast("Не удалось добавить запись", "error");
      }
    }
  };

  render() {
    const { multiple, allowCreate } = this.props;
    const { pending, checkedModels, listKey } = this.state;

    let extraListButtons = [];
    if (multiple && checkedModels.length) {
      extraListButtons.push(
        <button
          key="selectButton"
          onClick={this.onModelSelect}
          title="Выбрать"
          className="ml-2 btn btn-light-primary"
        >
          <i className="fa fa-mail-forward"></i>
          <label className="label label-primary">{checkedModels.length}</label>
        </button>
      );
    }

    if (allowCreate) {
      extraListButtons.push(
        <button
          key="createButton"
          onClick={this.onCreate}
          title="Создать"
          className="ml-2 btn btn-icon btn-light"
        >
          <i className="flaticon2-add-1 "></i>
        </button>
      );
    }

    const ModalComponent = this.props.keepModal ? Modal : BsModal;

    return (
      <ModalComponent
        center
        show={this.props.show}
        onClose={this.props.onClose}
      >
        <Blocker on={pending}>
          <ModelList
            limit={20}
            listKey={listKey}
            onModelPick={!multiple ? this.onModelPick : null}
            onModelCheck={multiple ? this.onModelCheck : null}
            checkedModels={this.state.checkedModels}
            extraButtons={extraListButtons}
          />
        </Blocker>
      </ModalComponent>
    );
  }
}
